/** Template / difficulty helpers for sliding puzzles (browse, play, mobile shell). */

export const DIFF_LEVELS = ["EASY", "MEDIUM", "HARD"];

export function formatStartingLayout(layout) {
    if (!Array.isArray(layout)) return "—";
    const n = layout.length;
    const preview = layout.slice(0, Math.min(16, n));
    const tail = n > 16 ? ", …" : "";
    return `[${preview.join(", ")}${tail}] (${n})`;
}

export function pickTemplate(templates, level) {
    if (!Array.isArray(templates)) return null;
    const byField = templates.find((t) => t?.difficultyLevel === level);
    if (byField) return byField;
    const idx = DIFF_LEVELS.indexOf(level);
    if (idx >= 0 && idx < templates.length) return templates[idx];
    return null;
}

export function templatesForDifficulty(templates, level) {
    if (!Array.isArray(templates)) return [];
    const byField = templates.filter((t) => t?.difficultyLevel === level);
    if (byField.length > 0) {
        return [...byField].sort((a, b) => (Number(a?.gridSize) || 0) - (Number(b?.gridSize) || 0));
    }
    const idx = DIFF_LEVELS.indexOf(level);
    if (idx >= 0 && idx < templates.length) {
        const t = templates[idx];
        return t ? [t] : [];
    }
    return [];
}

export function uniqueGridSizesSorted(templates) {
    if (!Array.isArray(templates)) return [];
    const sizes = new Set();
    for (const t of templates) {
        const g = Number(t?.gridSize);
        if (Number.isFinite(g) && g > 0) sizes.add(g);
    }
    return [...sizes].sort((a, b) => a - b);
}

export function templateForGridAndLevel(templates, gridSize, level) {
    const gs = Number(gridSize);
    if (!Number.isFinite(gs) || gs < 1 || !Array.isArray(templates)) return null;
    const forGs = templates.filter((t) => Number(t.gridSize) === gs);
    if (forGs.length === 0) return null;
    const byDiff = forGs.find((t) => t.difficultyLevel === level);
    if (byDiff) return byDiff;
    const idx = DIFF_LEVELS.indexOf(level);
    const hasDifficulty = forGs.some(
        (t) => t?.difficultyLevel != null && String(t.difficultyLevel).trim() !== "",
    );
    if (!hasDifficulty && idx >= 0 && idx < forGs.length) return forGs[idx];
    return null;
}
